
setTimeout(function() {
  
    var collectionBannerHeight = $('.template-collection .banner__text').height();
    console.log('collectionBannerHeight ='+collectionBannerHeight);
    var space = parseInt(collectionBannerHeight)/2 + 35;
     $('.template-collection .banner__text.container').css('bottom','-'+space+'px');
    $('.template-collection .banner.banner--bg-image').css('margin-bottom',+space+'px');
      $('.template-collection .banner__text.container').css('opacity','1');
  
}, 500);  


 $(window).resize(function() {

   var collectionBannerHeight = $('.template-collection .banner__text').height();
    console.log('collectionBannerHeight ='+collectionBannerHeight);
    var space = parseInt(collectionBannerHeight)/2 + 35;
     $('.template-collection .banner__text.container').css('bottom','-'+space+'px');
    $('.template-collection .banner.banner--bg-image').css('margin-bottom',+space+'px');

 });

// Cart Drawer Initialization & Event Handlers
window.theme = window.theme || {};

$(document).ready(function() {
  // Drawer helper functions
  theme.openCartDrawer = function() {
    document.documentElement.classList.add('open-side-drawer');
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.add('is-open');
    }
  };

  theme.closeCartDrawer = function() {
    document.documentElement.classList.remove('open-side-drawer');
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.remove('is-open');
    }
  };

  theme.updateCartBadge = function() {
    $.getJSON('/cart.js', function(cart) {
      var count = cart.item_count;
      var $badge = $('.header-items__cart-link .cart__count');
      if (count > 0) {
        if ($badge.length === 0) {
          $('.header-items__cart-link a').append('<span class="cart__count">(' + count + ')</span>');
        } else {
          $badge.text('(' + count + ')');
        }
      } else {
        $badge.remove();
      }
    });
  };

  theme.renderCartDrawerHTML = function(html) {
    console.log('theme.renderCartDrawerHTML called');
    if (!html) {
      console.error('theme.renderCartDrawerHTML: html is empty');
      return;
    }
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newInner = doc.querySelector('.cart-drawer__inner');
    
    if (newInner) {
      $('#CartDrawer .cart-drawer__inner').html(newInner.innerHTML);
      console.log('Cart Drawer inner HTML updated successfully');
    } else {
      console.error('Could not find .cart-drawer__inner in response HTML');
    }
    theme.updateCartBadge();
  };

  theme.refreshCartDrawer = function(openAfterRefresh) {
    console.log('theme.refreshCartDrawer called, openAfterRefresh:', openAfterRefresh);
    var $drawer = $('#CartDrawer');
    $drawer.addClass('loading');
    
    $.ajax({
      type: 'GET',
      url: '/cart?sections=cart-drawer&t=' + Date.now(),
      dataType: 'json',
      success: function(response) {
        console.log('theme.refreshCartDrawer success:', response);
        if (response && response['cart-drawer']) {
          theme.renderCartDrawerHTML(response['cart-drawer']);
        } else {
          console.error('refreshCartDrawer: response did not contain cart-drawer key');
        }
        $drawer.removeClass('loading');
        if (openAfterRefresh) {
          theme.openCartDrawer();
        }
      },
      error: function(err) {
        $drawer.removeClass('loading');
        console.error('Error refreshing cart drawer:', err);
      }
    });
  };

  theme.updateDrawerItem = function(line, quantity) {
    console.log('theme.updateDrawerItem called, line:', line, 'quantity:', quantity);
    var $drawer = $('#CartDrawer');
    $drawer.addClass('loading');
    
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: line,
        quantity: quantity,
        sections: 'cart-drawer'
      },
      dataType: 'json',
      success: function(response) {
        console.log('theme.updateDrawerItem success:', response);
        if (response && response.sections && response.sections['cart-drawer']) {
          theme.renderCartDrawerHTML(response.sections['cart-drawer']);
        } else {
          console.warn('updateDrawerItem: no inline sections returned, forcing refresh');
          theme.refreshCartDrawer(false);
        }
        $drawer.removeClass('loading');
      },
      error: function(err) {
        $drawer.removeClass('loading');
        console.error('Error updating cart item:', err);
        alert('Error updating cart. Please try again.');
      }
    });
  };

  theme.saveCartNote = function(note) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {
        note: note
      },
      dataType: 'json',
      success: function() {
        console.log('Cart note updated');
      },
      error: function(err) {
        console.error('Error updating cart note:', err);
      }
    });
  };

  // Intercept click on header cart icon or open-cart class elements
  $(document).on('click', '.header-items__cart-link a, .js-cart-drawer-toggle, a[href="/cart"]:not(.cart-drawer__content a):not(.cart-drawer__footer a)', function(e) {
    e.preventDefault();
    theme.openCartDrawer();
  });

  // Intercept close button click
  $(document).on('click', '#CartDrawer .side-drawer__close-btn', function(e) {
    e.preventDefault();
    theme.closeCartDrawer();
  });

  // Intercept "Add to Cart" form submissions
  $(document).on('submit', 'form[action*="/cart/add"]', function(e) {
    // Check if the form is in the cart drawer itself (e.g., checkout/updating shouldn't be intercepted)
    if ($(this).closest('#CartDrawer').length > 0) return;
    
    e.preventDefault();
    var $form = $(this);
    var $submitBtn = $form.find('[type="submit"]');
    var originalBtnText = $submitBtn.text();
    $submitBtn.prop('disabled', true).text('Adding...');

    var formData = $form.serialize();
    formData = formData ? formData + '&sections=cart-drawer' : 'sections=cart-drawer';

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(response) {
        $submitBtn.prop('disabled', false).text(originalBtnText);
        if (response && response.sections && response.sections['cart-drawer']) {
          theme.renderCartDrawerHTML(response.sections['cart-drawer']);
        } else {
          theme.refreshCartDrawer(false);
        }
        theme.openCartDrawer();
      },
      error: function(err) {
        $submitBtn.prop('disabled', false).text(originalBtnText);
        console.error('Error adding to cart:', err);
        var errMsg = err.responseJSON ? err.responseJSON.description : 'Failed to add item to cart.';
        alert(errMsg);
      }
    });
  });

  // Intercept Quantity Selector interactions inside Drawer
  $(document).on('click', '#CartDrawer .js-drawer-qty', function(e) {
    e.preventDefault();
    var $button = $(this);
    var $input = $button.closest('.qty-selector').find('.js-drawer-qty-input');
    var line = parseInt($button.attr('data-line'));
    var direction = $button.attr('data-direction');
    var currentVal = parseInt($input.val()) || 0;
    var newVal = direction === '+' ? currentVal + 1 : currentVal - 1;
    
    console.log('Cart Drawer Qty Button Clicked:', {
      line: line,
      direction: direction,
      currentVal: currentVal,
      newVal: newVal
    });

    if (!isNaN(line) && newVal >= 0) {
      theme.updateDrawerItem(line, newVal);
    } else {
      console.warn('Cart Drawer Qty Click rejected. Line or newVal is invalid.');
    }
  });

  // Intercept Quantity Input edits inside Drawer
  $(document).on('change', '#CartDrawer .js-drawer-qty-input', function(e) {
    var $input = $(this);
    var line = parseInt($input.attr('data-line'));
    var newVal = parseInt($input.val());
    
    console.log('Cart Drawer Qty Input Changed:', {
      line: line,
      newVal: newVal
    });

    if (!isNaN(line) && !isNaN(newVal) && newVal >= 0) {
      theme.updateDrawerItem(line, newVal);
    } else {
      console.warn('Cart Drawer Qty Input rejected. Line or newVal is invalid.');
      theme.refreshCartDrawer(false);
    }
  });

  // Intercept Remove button click inside Drawer
  $(document).on('click', '#CartDrawer .js-drawer-remove', function(e) {
    e.preventDefault();
    var line = parseInt($(this).attr('data-line'));
    console.log('Cart Drawer Remove Clicked, line:', line);
    if (!isNaN(line)) {
      theme.updateDrawerItem(line, 0);
    } else {
      console.warn('Cart Drawer Remove Click rejected. Line is NaN.');
    }
  });

  // Intercept Order Note update
  $(document).on('change blur', '#CartDrawer .js-drawer-note', function() {
    var noteVal = $(this).val();
    theme.saveCartNote(noteVal);
  });
});
